import {
    RequestConfigFunction,
} from 'app/types/request.types'

type EngagementRequests = {
    domainName: string,
    create: RequestConfigFunction<undefined>,
    get: RequestConfigFunction<{id: number}>,
    update: RequestConfigFunction<{id: number}>,
    archive: RequestConfigFunction<{id: number}>,
    restore: RequestConfigFunction<{id: number}>,
}

const engagementRequests: EngagementRequests = {
    domainName: 'Engagement',
    create: () => {
        return {
            url: 'engagement',
            method: 'POST',
        }
    },
    get: ({
        id,
    }) => {
        return {
            url: `engagement/${id}`,
            method: 'GET',
        }
    },
    update: ({
        id,
    }) => {
        return {
            url: `engagement/${id}`,
            method: 'PUT',
        }
    },
    archive: ({
        id,
    }) => {
        return {
            url: `engagement/${id}/archive`,
            method: 'PATCH',
        }
    },
    restore: ({
        id,
    }) => {
        return {
            url: `engagement/${id}/restore`,
            method: 'PATCH',
        }
    },
}

export default engagementRequests
